import type React from "react";
import { Fragment } from "react";
import { useResumeBuilder } from "../context";

interface ProgressBarProps {
    currentStep: 1 | 2 | 3;
}

const steps = [
    { step: 1, label: "Allgemeine Daten" },
    { step: 2, label: "Erfahrung" },
    { step: 3, label: "Foto & Farbe" },
];

export const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
    const { design } = useResumeBuilder();

    return (
        <div className="flex w-full items-center bg-white">
            {steps.map((item, index) => (
                <Fragment key={item.step}>
                    <div className="flex flex-col items-center justify-center gap-2">
                        <div
                            className="flex h-6 w-6 items-center justify-center rounded-full text-sm"
                            style={{
                                backgroundColor:
                                    item.step <= currentStep
                                        ? design.resumePrimaryColor
                                        : "#e5e7eb",
                                color: design.resumePrimaryContrastColor,
                            }}
                        >
                            {item.step}
                        </div>
                    </div>
                    {index !== steps.length - 1 && (
                        <div
                            className="h-0.5 flex-1"
                            style={{
                                backgroundColor:
                                    item.step + 1 <= currentStep
                                        ? design.resumePrimaryColor
                                        : "#e5e7eb",
                            }}
                        />
                    )}
                </Fragment>
            ))}
        </div>
    );
};
